import React from 'react';
import { Box, Tooltip, Typography, ButtonBase } from '@mui/material';
import { useCurrency, CURRENCIES, REGIONS } from '../contexts/CurrencyContext';

export default function CurrencyToggle() {
  const { currency, setRegion } = useCurrency();

  const isGBP = currency === CURRENCIES.GBP;
  const isUSD = currency === CURRENCIES.USD;

  const handleToggle = () => {
    setRegion(isGBP ? REGIONS.US : REGIONS.UK);
  };

  return (
    <Tooltip title="Switch between GBP (UK) and USD (US) currencies">
      <ButtonBase
        onClick={handleToggle}
        aria-label="toggle currency"
        sx={{
          width: 144, // width of the toggle
          height: 44,
          borderRadius: 22,
          border: '1px solid',
          borderColor: 'divider',
          backgroundColor: theme =>
            theme.palette.mode === 'dark'
              ? 'rgba(255,255,255,0.05)'
              : 'rgba(0,0,0,0.03)',
          overflow: 'hidden',
          position: 'relative',
          transition: 'border-color 0.3s ease-in-out',
          '&:hover': {
            borderColor: 'primary.main',
          },
        }}
      >
        {/* Slider */}
        <Box
          sx={{
            position: 'absolute',
            top: 4,
            left: isGBP ? 4 : 'calc(50% + 2px)',
            width: 'calc(50% - 6px)', // same padding as top+left+right+bottom
            height: 'calc(100% - 8px)',
            backgroundColor: 'rgb(0, 176, 116)',
            borderRadius: 16,
            transition: 'left 0.3s ease-in-out',
            zIndex: 1,
          }}
        />

        {/* GBP */}
        <Box
          sx={{
            width: '50%',
            zIndex: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 0.5,
            px: 1, // light horizontal padding
          }}
        >
          <Typography
            component="span"
            fontSize="1.1rem"
            sx={{
              filter: isGBP ? 'none' : 'grayscale(60%)',
              transition: 'filter 0.3s',
            }}
          >
            🇬🇧
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: isGBP ? 700 : 500,
              color: isGBP ? '#fff' : 'text.primary',
              textShadow: isGBP ? '0 1px 2px rgba(0,0,0,0.4)' : 'none',
              transition: 'all 0.3s ease-in-out',
            }}
          >
            GBP
          </Typography>
        </Box>

        {/* USD */}
        <Box
          sx={{
            width: '50%',
            zIndex: 2,
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            gap: 0.5,
            px: 1,
          }}
        >
          <Typography
            component="span"
            fontSize="1.1rem"
            sx={{
              filter: isUSD ? 'none' : 'grayscale(60%)',
              transition: 'filter 0.3s',
            }}
          >
            🇺🇸
          </Typography>
          <Typography
            variant="body2"
            sx={{
              fontWeight: isUSD ? 700 : 500,
              color: isUSD ? '#fff' : 'text.primary',
              textShadow: isUSD ? '0 1px 2px rgba(0,0,0,0.4)' : 'none',
              transition: 'all 0.3s ease-in-out',
            }}
          >
            USD
          </Typography>
        </Box>
      </ButtonBase>
    </Tooltip>
  );
}
